export default "__VITE_ASSET__DEWE2z3L__"